import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 28,
    height: 28,
    filter: 'invert(1)', // Always invert to make black icon white for dark sidebar
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      src="/planet-icon-circle-black.png"
      alt="WeArePlanet"
      className={classes.img}
    />
  );
};

export default LogoIcon;
